export const subscriptionFirstPaymentText = {
  goBack: 'Back to plans',
  title: 'Billing and subscription details',
  subtitle:
    "Thank you for choosing tapybl! You're just a step away from completing your order.",
  point1month: (price: string) =>
    `Your subscription will auto-renew at ${price}/month.`,
  point1year: (price: string) =>
    `Your subscription will auto-renew at ${price}/year.`,
  point2:
    'You can cancel anytime before the next billing cycle to avoid further charges.',
  point3: 'By completing your purchase, you agree to our ',
  terms: 'Terms of service and privacy policy.',
  info1: 'Please review your order details below and proceed to payment',
  info2:
    'If you have any questions or encounter any issues, feel free to reach out to our ',
  info3:
    'Your payment information is processed securely using Stripe. We do not store or share your card details.',
  support: 'support team.',
  summary: 'Summary',
  selectedTier: 'Selected plan',
  planDescription: 'Description',
  price: 'Price',
  cancel: 'Cancel',
  proceed: 'Proceed to payment',
  totalMonth: (price: string) => `Total: ${price} / month`,
  totalYear: (price: string) => `Total: ${price} / year`,
};
